// Continental US silhouette + decorative power-grid geometry for the map loading overlay.
// All coordinates live in a 1000x600 viewBox.
//
// US_OUTLINE_PATH is generated from the public-domain us-atlas `nation` TopoJSON
// (albersUsa projection, mainland polygon only, simplified). GRID_NODES are real
// city substation hubs projected into the same space. Lines/flows are decorative.
// Regenerate with: node scripts/generate_us_silhouette.mjs

export const VIEWBOX = { width: 1000, height: 600 }

export const US_OUTLINE_PATH = 'M100.9,32.8L103.3,28.6L111.2,36.1L128,41.5L129.4,59.6L134.6,46L133,24L230.4,34.9L327.8,47.4L425.1,61.6L521.8,77.4L526.4,71.1L529.2,82.8L541.4,87.3L552.9,84.7L571.6,93L602.6,95.6L589.1,102.7L567.8,122.9L583.7,119.3L592,127L606.4,120.1L623.8,105.5L623.8,116.9L637.1,124.4L649.1,124.6L655.3,119.5L672.5,115.5L672.1,121.7L683.7,119.2L687.1,128.2L695.2,131.1L663.9,133.7L644,138.5L631.6,163.8L632.1,167.8L645,154.6L639.7,166.7L635.4,195.6L638.3,215.6L646.1,229.2L658.3,222.6L662.8,210.2L662,197.8L655.8,184.5L657.9,161.9L666.4,150.3L676.4,144.7L677.5,136L697.7,142.8L702.1,149.5L703.1,164.2L695.2,178L699.9,180.9L710.2,169.1L715.1,173.2L721,190.7L708.6,218.6L725.1,225.6L736.5,221.6L773.2,192.2L776.9,186.5L771.7,176.9L780.1,172.9L804,170.6L813.8,162.8L809.6,149L828,127L877,115L890.2,91.9L889.3,74.3L895.7,55.5L901.9,59.9L910.2,53.5L918.3,57.5L926.8,86L944.1,100.1L937.6,110.3L925.2,118.3L919.5,114.6L916.9,128.5L902.3,141.1L899.1,167.3L909.3,177.8L919.4,177.7L897.3,190.9L876.1,199.2L865.7,207.1L889.8,201.4L874.4,213.3L858.4,220.3L863.7,221.6L864.8,235L855.1,250.6L843.2,246.5L855.9,267L848.9,296.1L845.3,295L848,278.7L834.7,269.9L838.2,293.3L847.3,302L851.6,316.1L840.4,325.3L854.8,321.7L857.1,329.6L843.3,347.1L851.4,345.1L848.6,353.4L831.8,360.6L827.1,373.9L814.2,377.5L805.9,396.4L788,411.4L779,429L776.2,450.2L783,470L799.9,494L801.7,504.3L814.4,525.5L817.9,553.4L814.2,565.1L802,568.5L796.1,557.2L787.8,555L782.7,544.4L763.4,523.1L768.2,515.1L759.5,515.7L759.4,493.2L739,474.7L726.8,471.7L713.7,484.3L696,472.2L682.6,470.2L661.4,475.7L640.9,473.9L630.5,481.4L631.1,496.3L613.9,498.2L607.2,505.1L586.2,489.1L578.4,496L562.3,491.4L544.5,494.5L521.3,511.5L501.4,522.8L494.7,521.8L482.6,544.4L482.9,576L449.4,562.6L443,539.8L428.3,522.2L422,504.4L407.8,489L386,488.6L376,504L351.2,487.9L344,464.6L337.2,460.3L318.7,438.2L288.5,434.6L287.2,444.2L235.3,436.7L173.1,400.1L175.7,395.6L132.6,390.5L129.8,372.2L115.3,353.1L99.9,341L84.5,336.2L85.5,321.3L71.5,287L75.9,281L68.2,270L72.3,253.8L57.4,227.1L61.2,208.4L55.9,197L68,174L69.4,142.8L79.9,127.4L104.3,66.3L100.8,64.6Z'

export const GRID_NODES = [
  { key: 'seattle', x: 131, y: 54 },
  { key: 'bayArea', x: 74, y: 258 },
  { key: 'la', x: 121, y: 354 },
  { key: 'phoenix', x: 225, y: 389 },
  { key: 'denver', x: 363, y: 270 },
  { key: 'minneapolis', x: 551, y: 163 },
  { key: 'chicago', x: 642, y: 225 },
  { key: 'dallas', x: 495, y: 427 },
  { key: 'houston', x: 521, y: 492 },
  { key: 'atlanta', x: 715, y: 394 },
  { key: 'dc', x: 821, y: 263 },
  { key: 'miami', x: 817, y: 552 }
]

const NODES_BY_KEY = Object.fromEntries(GRID_NODES.map((node) => [node.key, node]))

const connect = (from, to) => ({
  x1: NODES_BY_KEY[from].x,
  y1: NODES_BY_KEY[from].y,
  x2: NODES_BY_KEY[to].x,
  y2: NODES_BY_KEY[to].y
})

export const GRID_LINES = [
  connect('seattle', 'bayArea'),
  connect('bayArea', 'la'),
  connect('la', 'phoenix'),
  connect('phoenix', 'denver'),
  connect('phoenix', 'dallas'),
  connect('denver', 'minneapolis'),
  connect('denver', 'chicago'),
  connect('denver', 'dallas'),
  connect('minneapolis', 'chicago'),
  connect('chicago', 'dc'),
  connect('dallas', 'houston'),
  connect('houston', 'atlanta'),
  connect('atlanta', 'dc'),
  connect('atlanta', 'miami')
]

export const FLOW_LINES = [
  connect('denver', 'minneapolis'),
  connect('minneapolis', 'chicago'),
  connect('chicago', 'dc'),
  connect('denver', 'dallas'),
  connect('houston', 'atlanta'),
  connect('atlanta', 'dc')
]
